/**
 * How a reviewer's name is shown. EQL's reviews are written by Vietnamese
 * customers; on a partner storefront (Thailand) the full Vietnamese name
 * next to a translated review reads foreign, and inventing local names would
 * misrepresent who wrote it. Partner markets show initials (diacritics
 * folded) beside the verified-buyer badge instead: "Đặng Mỹ Linh" → "D.M.L."
 */
export function reviewerDisplayName(name: string | null | undefined, opts: { initials: boolean }): string {
  const clean = String(name ?? "").replace(/\s+/g, " ").trim();
  if (!clean) return "";
  if (!opts.initials) return clean;
  const fold = (s: string) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[đĐ]/g, "D");
  const parts = clean.split(" ").filter(Boolean);
  const initials = parts.map((p) => fold(p).charAt(0).toUpperCase()).filter((c) => /[A-Z0-9]/.test(c));
  return initials.length ? initials.map((c) => c + ".").join("") : clean.charAt(0).toUpperCase() + ".";
}
